import React, { useState, useEffect } from 'react';
import '../css/MainnetProgress.css'; 

const MainnetProgress = () => {
  const [blockCount, setBlockCount] = useState(0);
  const [blocksRemaining, setBlocksRemaining] = useState(0);
  const [nextHalvingDate, setNextHalvingDate] = useState('');
  const [halvingsCompleted, setHalvingsCompleted] = useState(0);
  const [currentReward, setCurrentReward] = useState(540);
  const [nextReward, setNextReward] = useState(540);

  const halvings = [
    { block: 129600, reward: 540 },
    { block: 259200, reward: 459 },
    { block: 388800, reward: 367.2 },
    { block: 518400, reward: 200 },
    { block: 1036800, reward: 100 },
    { block: 1555200, reward: 50 },
    { block: 2073600, reward: 25 }
  ];

  const blockInterval = 1;

  useEffect(() => {
    const fetchBlockCount = async () => {
      try {
        const response = await fetch('https://aidp-rpc-mainnet.ai-depin.org/rpc', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jsonrpc: '2.0',
            method: 'getblockcount',
            params: [],
            id: 1
          }),
        });
        
        const data = await response.json();
        const blockCount = data.result;
        setBlockCount(blockCount);

        // Calculate the halving data
        const halvingData = calculateHalving(blockCount);
        setBlocksRemaining(halvingData.blocksRemaining);
        setNextHalvingDate(halvingData.nextHalvingDate);
        setHalvingsCompleted(halvingData.halvingsCompleted);
        setCurrentReward(halvingData.currentReward);
        setNextReward(halvingData.nextReward);
      } catch (error) {
        console.error('Error fetching block count through RPC proxy:', error);
      }
    };

    fetchBlockCount();
  }, []);

  // Function to calculate halving details
  const calculateHalving = (currentBlock) => {
    let completed = 0;
    let nextHalvingBlock = 0;
    let reward = halvings[0].reward;
    let nextReward = halvings[0].reward;

    for (let i = 0; i < halvings.length; i++) {
      if (currentBlock >= halvings[i].block) {
        completed = i + 1;
        reward = halvings[i].reward;
        nextReward = halvings[i + 1] ? halvings[i + 1].reward : reward;
      } else {
        nextHalvingBlock = halvings[i].block;
        nextReward = halvings[i].reward;
        break;
      }
    }

    const blocksRemaining = nextHalvingBlock - currentBlock;

    // Estimate the date of the next halving (in minutes to date)
    const estimatedMinutes = blocksRemaining * blockInterval;
    const estimatedDate = new Date(Date.now() + estimatedMinutes * 60 * 1000);

    const nextHalvingDate = estimatedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    return {
      blocksRemaining: blocksRemaining > 0 ? blocksRemaining : 0,
      nextHalvingDate,
      halvingsCompleted: completed,
      currentReward: reward,
      nextReward
    };
  };

  return (
    <div className="mainnet-progress">
      <h2>Mainnet Progress</h2>
       <p>Monitor the Mainnet’s progress with real-time data, including the current block mined, blocks 
       remaining until the next halving, upcoming halving date, current block rewards and next block rewards.</p>
      <div className="mainnet-info">
        <div className="info-row">
          <div className="info-card">
            <strong>Current Blocks Mined</strong>
            <span>{blockCount}</span>
          </div>
          <div className="info-card">
            <strong>Blocks Remaining Until Next Halving</strong>
            <span>{blocksRemaining}</span>
          </div>
          <div className="info-card">
            <strong>Approximate Date of Next Halving</strong>
            <span>{nextHalvingDate}</span>
          </div>
        </div>
        <div className="info-row">
          <div className="info-card">
            <strong>Number of Halvings Completed</strong>
            <span>{halvingsCompleted}</span>
          </div>
          <div className="info-card">
            <strong>Current Block Rewards</strong>
            <span>{currentReward} AIDP</span>
          </div>
          <div className="info-card">
            <strong>Next Block Rewards</strong>
            <span>{nextReward} AIDP</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainnetProgress;
